import type { IAddress } from '@/types';
import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IRecipientInfoProps extends IAddress {
  fullname: string;
}

export const RecipientInfo: React.FC<IRecipientInfoProps> = ({
  city,
  countryCode,
  fullname,
  streetAddress,
  zipCode,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Box>
      <Text textTransform="uppercase">{t('QUOTE_DETAILS.RECIPIENT')}</Text>
      <Text fontSize="h4" fontWeight="bold" textTransform="capitalize">
        {fullname}
      </Text>
      <Text>
        {streetAddress}
        <br /> {zipCode} {city} {countryCode}
      </Text>
    </Box>
  );
};
